angular.module('core')
    .directive('localDatePicker', ['$filter', '$timeout', function () {
        return {
            scope: {
                disabled: '=',
            },
            replace: false,
            require: 'ngModel',
            template: '<input type="text" ng-model="localDate" class="form-control input-sm center" ng-change="onChange()" ng-disabled="disabled" ng-required="required" local-date-parser \n' +
            '                   datetimepicker options="{ locale: \'pl\', format: \'YYYY-MM-DD\', focusOnShow: false, showTodayButton: true, showClose: true, showClear: true, allowInputToggle: true }"/>',
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.format = "YYYY-MM-DD";
                scope.locale = "pl";
                scope.required = $attrs.required;

                scope.onChange = value => {

                };

                ngModelCtrl.$render = () => scope.localDate = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);
                // ngModelCtrl.$isEmpty = function (modelValue) {
                //     return modelValue === null;
                // };
                // ngModelCtrl.$validators.isRequired = function (modelValue, viewValue) {
                //     return scope.localDate !== null;
                // };
                scope.$watch('localDate', () => {
                    ngModelCtrl.$setViewValue(scope.localDate);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                });
            }
        };
    }]);
